import axios from 'axios'

var currentUser = JSON.parse(localStorage.getItem('currentUser'))
axios.defaults.headers.common['Authorization'] = currentUser ? 'Bearer ' + currentUser.token : ''

// Add a request interceptor
axios.interceptors.request.use(function (config) {
    // Do something before request is sent
    //console.log('interceptors request')
    //console.log(config)

    
    return config;
  }, function (error) {
    // Do something with request error
    return Promise.reject(error);
  });

// Add a response interceptor
axios.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    //console.log('interceptors response')
    //console.log(response)


    return response;
  }, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    //console.log('interceptors response error')
    console.log(JSON.stringify(error))

        if (error.response.status == 401) {

            if (error.response.config.headers.referpage == null || error.response.config.headers.referpage == '') {
                window.location.href = '/auth/logout'
            }

            /*
            if (error.response.config.headers.referpage != null) {
                if (error.response.config.headers.referpage != '/meeting/accept') {
                    window.location.href = '/auth/logout'
                }
            }
            else {
                window.location.href = '/auth/logout'
            }
            */
        }


    return Promise.reject(error);
  });

export function setAuthHeader(token) {
    axios.defaults.headers.common['Authorization'] = token ? 'Bearer ' + token : ''
}

export function SetBearer() {
    var currentUser = JSON.parse(localStorage.getItem('currentUser'))
    axios.defaults.headers.common['Authorization'] = currentUser ? 'Bearer ' + currentUser.token : ''
}